import React, { createContext, useContext } from "react";
import type { ReactNode } from "react";

export type OrgRole = "ADMIN" | "USER" | "VIEWER" | string;

export interface Organisation {
  id: string;
  name: string;
  slug: string;
  // Add more fields as needed
}

export interface OrgContextValue {
  organisation: Organisation | null;
  user: { id: string; name: string; email: string } | null;
  orgRole: OrgRole | null;
}

const OrgContext = createContext<OrgContextValue | undefined>(undefined);

export const OrgProvider = ({
  value,
  children,
}: {
  value: OrgContextValue;
  children: ReactNode;
}) => <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;

export function useOrgContext() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error("useOrgContext must be used within an OrgProvider");
  return ctx;
}
